import React, { createContext, useContext, useEffect, useMemo } from 'react';

import { useCreateShoppingBasket } from './ShoppingBasketCreationProvider.hook';

type ShoppingBasketContextType = {
  shoppingBasketId: string;
  shoppingBasketToken: string;
} | null;

const ShoppingBasketContext = createContext<ShoppingBasketContextType>(null);

export const useShoppingBasketCreation = () =>
  useContext(ShoppingBasketContext);

const ContextProvider = ({
  children,
  shoppingBasketId,
  shoppingBasketToken,
}: {
  children: React.ReactNode;
  shoppingBasketId: string;
  shoppingBasketToken: string;
}) => {
  const value = useMemo(
    () => ({ shoppingBasketId, shoppingBasketToken }),
    [shoppingBasketId, shoppingBasketToken]
  );
  return (
    <ShoppingBasketContext.Provider value={value}>
      {children}
    </ShoppingBasketContext.Provider>
  );
};

export const ShoppingBasketCreationProvider = ({
  children,
}: {
  onSuccess?: (shoppingBasketId: string) => void;
  children: React.ReactNode;
}) => {
  const { createShoppingBasket, shoppingBasketId, shoppingBasketToken } =
    useCreateShoppingBasket();

  useEffect(() => {
    createShoppingBasket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shoppingBasketId && shoppingBasketToken ? (
    <ContextProvider
      shoppingBasketId={shoppingBasketId}
      shoppingBasketToken={shoppingBasketToken}
    >
      {children}
    </ContextProvider>
  ) : null;
};
